<template>
    <div id="listUserLog">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> User Log Entry</div>
                    <a href="javascript:void(0)" class="btn btn-primary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content user-log-entry">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'UserLogList'" ref="filterUserLog" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'UserLogList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listUserLogTable"
                                    mode="remote"
                                    title="User Log Entry"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <template v-if="props.column.field == 'action'">
                                                <template v-if="canUpdate">
                                                    <router-link title="Edit User Log Entry" class="fp-edit pull-left" style="line-height:20px;" v-bind:to="{name: 'UserLogEntryEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                                <span v-if="canUpdate" class="pull-left">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                                                <template v-if="canChangeStatus">
                                                    <template v-if="props.row.status.toLowerCase() != 'approved'">
                                                    <a href="javascript:void(0);" v-on:click.prevent="changeStatus(props.row.id)" class="pull-left" style="line-height:20px;">
                                                        <span style="font-size:16px;" title="Approve Log" class="fp-ok-icon color-green"></span>
                                                    </a>
                                                    <span v-if="canChangeStatus" class="pull-left">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                                                    </template>
                                                </template>

                                                <template v-if="canView">
                                                    <router-link title="View User Log Entry" class="fp-view" v-bind:to="{name: 'UserLogEntryView',params:{id:props.row.id}}"></router-link>
                                                </template>
                                                <!-- <router-link title="Edit User Log Entry" class="glyphicon glyphicon-edit" v-bind:to="{name: 'UserLogEntryEdit',params:{id:props.row.id}}"></router-link> -->
                                            </template>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import EventBus from "./../event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import { contractMixins } from '../../mixins/contractMixins';
export default {
    name: "UserLogEntryNew",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "User Log Entry | " +process.env.COPYRIGHT_NAME
    },
    mixins:[contractMixins,commonMixins,dataTableMixins],
    data: () => ({
        firstLoad : 0,
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Date",
                field: "current_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Total Maintenance",
                field: "total_maintenance",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Total Maintenance", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Total Break",
                field: "total_break",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Total Break", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Total",
                field: "total_time",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Total", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Updated Total",
                field: "updated_total",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Updated Total", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },

            {
                label: "Status",
                field: "status",
                fpFieldType:"option",
                hidden:false,
                filterable: true,
                // type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ["Approve", "Disapprove"], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        loading:false,
        action:"list",
        cantAccessPage:"",
        canUpdate:false,
        canView:false,
        canChangeStatus:false
    }),
    watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'user_log_entry_list') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'user_log_entry_add') {
                    self.canUpdate = true;
                }
                if(permissions.name == 'user_log_entry_view') {
                    self.canView = true;
                }
                if(permissions.name == 'user_log_entry_status_change') {
                    self.canChangeStatus = true;
                }

            });
        },
    },
    created: function() {
        var self = this;
    },
    mounted: function () {

        this.getPermissions();
    },
    methods: {
        cancelAll: function (cancelAll) {
              this.$refs.listUserLogTable.unselectAllInternal();
            },
        selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
        loadList() {
            var self = this;
            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
            };
            self.firstLoad = 1;

            $.ajax({

                url: process.env.ROOT_API + "/user-workdata/list",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data:fields,

                success: function(data) {
                  self.loading = false;
                  if (data.status == "success") {
                      if (self.action =='export'){

                        self.action = 'list';
                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                            self.excel = data.content.web;
                            var save = document.createElement("a");
                            save.href = self.excel;
                            save.download = data.content.web;
                            save.target = "_blank";

                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);
                        }
                    }else{
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                  }

                },
                error: function(jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
                }
            });
        },
        changeStatus(logId) {
            var self = this;
            if (confirm('Are you sure that you want to approve User Log Entry? ')) {
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/user-workdata/status-change",
                    type: "POST",
                    data: {id:logId},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.$swal('','User Log Entry Status Updated Successfully.','success');
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'user-log-change-status');
                    }
                });
            }
        },
        exportReports: function() {
            var self = this;
            this.action = "export";
            this.loadList();
        },
    }

}
</script>



// WEBPACK FOOTER //
// src/components/WorkEntry/UserLogEntryNew.vue